import Lead from "@/model/Lead";
import Axios from "@/utils/axios/Axios";
import ENV from "@/utils/constants/environment";

const RESOURCE_NAME = "offer";
const RESOURCE_SAVINGS = "savings";

export default {
  getOffers(lead: Lead, cups: string, cupsGas: string, powerOptimized = true) {
    if (!cups) {
      cups = "";
    }
    if (!cupsGas) {
      cupsGas = "";
    }
    return Axios().post(
      ENV.API_URL +
        RESOURCE_NAME +
        `/get-offers?cups=${encodeURIComponent(
          cups
        )}&cupsGas=${encodeURIComponent(
          cupsGas
        )}&potencia_optimizada=${powerOptimized}`,
      lead.toJSONObject()
    );
  },
  sendOffers(offers: any) {
    return Axios().post(ENV.API_URL + RESOURCE_NAME + "/send-offers", offers);
  },
  getSavings(savingsData: any) {
    return Axios().post(
      ENV.API_URL + RESOURCE_SAVINGS + "/get-savings",
      savingsData
    );
  },
  getNationalities(documentNumber: string) {
    return Axios().get(
      ENV.API_URL + RESOURCE_NAME + `/get-nationalities?nif=${documentNumber}`
    );
  }
};
